var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.815,
    height: 12.815,
    viewBox: "0 0 12.815 12.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Supplier",
    transform: "translate(-282 -944.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logout_FILL0_wght400_GRAD0_opsz48",
    d: "M7.068,18.815A1.095,1.095,0,0,1,6,17.747V7.068A1.095,1.095,0,0,1,7.068,6h5.18V7.068H7.068v10.68h5.18v1.068Zm8.65-3.293-.765-.765,1.816-1.816h-6.23V11.874h6.194l-1.816-1.816.765-.765,3.133,3.133Z",
    transform: "translate(276 938.254)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplier);
export default __webpack_public_path__ + "static/media/supplier.2e0da9b052c526346b5d1d2ed1777c86.svg";
export { ForwardRef as ReactComponent };